module.exports = __webpack_public_path__ + "static/image/history/m/201501@3x.jpg?72b14f11";